import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../Select';
import { LocalizationContext } from '../../../hoc/Localization';
import styles from './styles.less';

const Header = ({ title, options, onChange }) => {
  const { t } = React.useContext(LocalizationContext);

  const renderer = option => (
    <div>
      <span role="img">
        <img
          style={{ width: '20px', height: '20px', marginRight: '10px' }}
          src={option.image}
          alt="option"
        />
      </span>
      {option.title}
    </div>
  );

  return (
    <div className={styles.headerPath}>
      <div>
        <h2>{title}</h2>
      </div>
      <div className={styles.selectLink}>
        <Select
          size="large"
          dropdownClassName={styles.dropSelect}
          onChange={e => onChange(e)}
          placeholder={t('path.competencies')}
          options={options}
          renderOption={o => renderer(o)}
          className={styles.pathSelect}
          defaultValue={options && options[0] && options[0].id}
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
};

Header.defaultProps = {
  options: [],
};

export default Header;
